module.exports = __webpack_public_path__ + "static/media/attributes-icon-large.8e15dc7d.svg";